import { COLORS } from 'Components/utils/color/colors';

const variants = {
  diamond: {
    root: ' rotate-45',
    item: ' -rotate-45',
  },
  pill: {
    root: ' rounded-full',
    item: '',
  },
};

export const themes = {
  default: ({
    colorBg = COLORS.BLUE,
    colorBorder = COLORS.BLUE,
    color = COLORS.WHITE,
    hasShadow,
    variant,
  }) => ({
    thRoot: `bg-${colorBg} border-${colorBorder} text-${color} border-2 flex-none inline-flex items-center justify-center leading-none overflow-hidden relative${
      hasShadow ? ' shadow' : ''
    }${variant ? variants[variant].root : ''}`,
    thImage: `absolute inset-0 ${variant ? variants[variant].item : ''}`,
    thIcon: `absolute flex items-center justify-center inset-0${
      variant ? variants[variant].item : ''
    }`,
    thIconSize: '65%',
    thLabel: `absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ${
      variant ? variants[variant].item : ''
    }`,
    thLabelStyle: { fontSize: '1em' },
  }),
};
